import React from "react";
import { Html, Text } from "@react-three/drei";
import { useSpring, animated, config } from "@react-spring/three";
import TextComponent from "./TextComponent";

export default function QS({ currentSection, isMobile }) {
  const Line = ({ txt, delay, fs, w1, w2, w3 }) => {
    const width = window.innerWidth;
    const isMobile = width < 470;
    const initialFS = fs + "em";
    const incrementedFS = w1 == "CREAMOS" ? fs + 1.8 : fs + 1;

    const formattedFS = incrementedFS + "rem";

    const { opacity, fontSize } = useSpring({
      config: config.slow,
      from: { opacity: 0, fontSize: initialFS },
      to: { opacity: 1, fontSize: formattedFS },
      delay,
    });

    const accent = {
      // flip horizontally
    };

    if (isMobile) {
      return (
        <>
          <Text>{w1.toUpperCase()}</Text>
          <Text>{w2}</Text>
          <Text>{w3}</Text>
        </>
      );
    }

    return (
      <animated.p style={{ fontSize, opacity }}>
        {txt.toUpperCase()}
        {(fs == 2 || fs == 0.4) && <span style={accent}> \</span>}
      </animated.p>
    );
  };

  const width = window.innerWidth;

  return (
    <>
      <TextComponent
        txt={"SOMOS DISRUPTORES"}
        weight="light"
        fs={isMobile ? 0.06 : 0.2}
        position={[0, 0, 0]}
        rotation={[0, 0, 0]}
      />
      <TextComponent
        txt={"diseñamos EXPERIENCIAS CREATIVAS"}
        weight="light"
        fs={isMobile ? 0.06 : 0.2}
        position={[0, isMobile ? -0.15 :-0.3, 0]}
        rotation={[0, 0, 0]}
      />
      <TextComponent
        txt={"DESARROLLAMOS HERRAMIENTAS DIGITALES "}
        weight="light"
        fs={isMobile ? 0.06 : 0.2}
        position={[0, isMobile ? -0.3 : -0.6, 0]}
        rotation={[0, 0, 0]}
      />
    </>
    // <main style={{ textAlign: "center" }}>
    //   <Line
    //     txt="SOMOS DESARROLLADORES CREATIVOS"
    //     delay={500}
    //     fs={width > 470 ? 1 : 0.3}
    //     w1="SOMOS"
    //     w2="DESARROLLADORES"
    //     w3="CREATIVOS"
    //   />
    //   <Line
    //     txt="/ CREAMOS HERRAMIENTAS DIGITALES "
    //     delay={1000}
    //     fs={width > 470 ? 2 : 0.4}
    //     w1="CREAMOS"
    //     w2="HERRAMIENTAS"
    //     w3="DIGITALES"
    //   />
    //   <Line
    //     txt="diseñamos EXPERIENCIAS ESPECTACULARES"
    //     delay={1500}
    //     fs={width > 470 ? 3 : 0.5}
    //     w1="diseñamos"
    //     w2="EXPERIENCIAS"
    //     w3="ESPECTACULARES"
    //   />
    // </main>
  );
}
